import React, { useEffect, useState, useMemo } from 'react';
import Grid from '@mui/material/Grid2';
import { Box, Container, Autocomplete, TextField } from '@mui/material';
import { getCompaniesForDropdown } from '../../../api/GBENSDec';
import { useNavigate, useLocation } from 'react-router-dom';
import WarningIcon from '@mui/icons-material/Warning';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { isEORIUser, is360PayStaff } from '../../../utils/roles';
import SetEORINumberModal from '../../../components/Modals/SetEORINumberModal/SetEORINumberModal';

export default function SelectCompanyForENS() {
  const [customer, setCustomer] = useState([]);
  const [selectedData, setSelectedData] = useState({});
  const { state } = useLocation();
  const [inputValue, setInputValue] = React.useState('');
  const [value, setValue] = useState('');
  const navigate = useNavigate();
  const [image, setImage] = useState('');
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [eoriNumber, setEoriNumber] = useState('');
  const [companyNames, setCompanyNames] = useState('');

  const [showEORIModal, setShowEORIModal] = useState(false);
  const [modalCompany, setModalCompany] = useState(null);

  const apiCall = async () => {
    getCompaniesForDropdown(sessionStorage.getItem('companyid')).then((data) => {
      if (!isEORIUser()) {
        for (let i = 0; i < data.data.length; i++) {
          if (sessionStorage.getItem('companyid') == data.data[i].companyId) {
            setValue(data.data[i].companyName);
            setCustomer([data.data[i]]);
            setSelectedData((prevData) => {
              return {
                ...prevData,
                ['customer']: parseInt(sessionStorage.getItem('companyid')),
              };
            });
          }
        }
      } else {
        setCustomer(data.data);
      }
    });
  };

  useEffect(() => {
    async function fetchData() {
      try {
        await apiCall();
      } catch (err) {
        console.log(err);
      }
    }
    fetchData();
  }, []);

  useEffect(() => {
    if (modalCompany) {
      setModalCompany(null);
      navigateToENS();
    }
  }, [customer, modalCompany]);

  useEffect(() => {
    if (state?.res) {
      setSelectedData((prevData) => {
        return {
          ...prevData,
          ['customer']: state.res.companyId,
        };
      });
    }
  }, [state?.res]);

  const navigateToENS = () => {
    //using the id in selectedData.customer, find the customer object in the customer array, looking for the record where companyId matches selectedData.customer
    const currentCompany =
      Object.keys(selectedData).length === 0
        ? customer[0]
        : customer.find((company) => company.companyId === (selectedData.companyId || selectedData.customer));

    if (!currentCompany.companyEori || currentCompany.companyEori.trim() === '') {
      // company has no EORI number - therefore we should ask for one
      setShowEORIModal(true);
      setModalCompany(currentCompany);
      return;
    }

    setCompanyNames(currentCompany.companyName);
    setEoriNumber(currentCompany.companyEori);
    if (!isEORIUser()) {
      navigate('/EnsDeclaration', { state: { companyId: currentCompany.companyId, currentCompany: currentCompany } });
    } else {
      setIsConfirmModalOpen(true);
    }
  };

  const handleClose = () => setIsConfirmModalOpen(false);
  const handleNavigation = () => {
    const currentCompany =
      Object.keys(selectedData).length === 0
        ? customer[0]
        : customer.find((company) => company.companyId === (selectedData.companyId || selectedData.customer));
    navigate('/EnsDeclaration', {
      state: { companyId: currentCompany.companyId, currentCompany: currentCompany, image: image },
    });
  };

  const hideDropdown = (!isEORIUser() && customer.length <= 1) || is360PayStaff();

  const onEORINumberUpdated = async () => {
    await apiCall();
  };

  return (
    <>
      <SetEORINumberModal
        isOpen={showEORIModal}
        setIsOpen={setShowEORIModal}
        company={modalCompany}
        onContinue={onEORINumberUpdated}
      />
      <Container maxWidth="lg">
        {' '}
        {/* Sets maximum width, with automatic margins */}
        <Grid container className="two-column">
          <Grid item xs={3} className="two-column-divs left-container">
            <div>
              <p className="create-ens">Create an ENS Declaration</p>
            </div>
          </Grid>
          <Grid item xs={9} className="two-column-divs right-container">
            <Box className="two-column">
              <Grid item xs={12} className="two-column-divs right-container">
                <div style={{ padding: '20px 20px 20px 40px' }}>
                  <p>
                    To create an ENS Declaration you need the Transport and Journey details, and details of each
                    consignment on the truck.
                  </p>
                  <p>
                    Note: Each consignment is sent to HMRC individually - all your consignments must be ACCEPTED 2 hours
                    before arrival of the ferry operator. You can amend a declaration if details change within the time
                    period.
                  </p>
                  <p>
                    This is a legal declaration of the goods to HMRC - any discrepancies may result in your company
                    receiving fines or Penalties issued by HMRC.
                  </p>
                  <div>
                    <Autocomplete
                      value={value}
                      fullWidth
                      className="hover-classes disabled"
                      onChange={(event, newValue) => {
                        // const base64String = ;
                        // console.log(new Uint8Array(newValue?.logo?.data));
                        let binary = '';
                        if (newValue?.logo?.data) {
                          let bytes = new Uint8Array(newValue.logo?.data);
                          let len = bytes.byteLength;
                          for (let i = 0; i < len; i++) {
                            binary += String.fromCharCode(bytes[i]);
                          }
                          setImage(btoa(binary));
                        }
                        setEoriNumber(newValue?.companyEori);
                        setSelectedData((prevData) => {
                          return {
                            ...prevData,
                            ['companyId']: newValue?.companyId,
                          };
                        });
                        setValue(newValue?.companyName);
                      }}
                      inputValue={inputValue}
                      onInputChange={(event, newInputValue) => {
                        setInputValue(newInputValue);
                      }}
                      id="controllable-states-demo"
                      options={customer}
                      sx={{ width: 300, marginTop: 3, backgroundColor: '#fff' }}
                      getOptionLabel={(option) => {
                        return `${option.companyName || option}`;
                      }}
                      renderOption={(props, option) => {
                        const { key, ...optionProps } = props;
                        return (
                          <li key={key} {...optionProps}>
                            {option.companyName || option}
                          </li>
                        );
                      }}
                      renderInput={(params) => <TextField {...params} label="Select Customer" />}
                      hidden={hideDropdown}
                    />

                    {hideDropdown && (
                      <p>
                        {inputValue?.length && !is360PayStaff() ? (
                          <span style={{ fontWeight: 'bold' }}>Your Company: {inputValue}</span>
                        ) : (
                          <span style={{ fontWeight: 'bold' }}>You have no permission to create an ENS</span>
                        )}
                      </p>
                    )}
                  </div>
                  <div className="ens-footer">
                    <a href="https://www.eori.uk/customs-knowledge/how-to-create-an-ens-declaration" target="_blank">
                      Quick start guide
                    </a>
                    <button onClick={navigateToENS} disabled={!value}>
                      Create ENS
                    </button>
                  </div>
                </div>
              </Grid>
            </Box>
          </Grid>
        </Grid>
        <Dialog
          open={isConfirmModalOpen}
          onClose={handleClose}
          className="usersTable declaration-pop"
          PaperProps={{
            component: 'form',
            onSubmit: (event) => {
              event.preventDefault();
              const formData = new FormData(event.currentTarget);
              const formJson = Object.fromEntries(formData.entries());
              const email = formJson.email;
              console.log(email);
              handleClose();
            },
          }}
        >
          <DialogTitle>
            <WarningIcon className="svg-icons warning-modal" style={{ color: 'orange' }} />
            <span className="dialog-title">Confirm ENS Customer</span>
            <IconButton className="right-aligned" onClick={handleClose} aria-label="close">
              <CloseIcon />
            </IconButton>
          </DialogTitle>

          <DialogContent className="edit-add-trader-user">
            <DialogContentText className="dialog-content-body">
              <p>Please confirm you are completing an ENS for the following customer</p>
              <div className="modal-text-image">
                <div className="left-aligned-text">
                  <span>{companyNames}</span>
                  <span>{eoriNumber}</span>
                </div>
                {image && (
                  <div className="image-display" style={{ backgroundImage: `url('data:image/png;base64,${image}')` }} />
                )}
              </div>
            </DialogContentText>
          </DialogContent>
          <DialogActions className="space-between" sx={{ px: 3, pb: 3 }}>
            <Button onClick={handleClose} className="button-class cancel-btton" sx={{ minWidth: 100 }}>
              Cancel
            </Button>
            <Button onClick={handleNavigation} className="button-class confirm-btton" sx={{ minWidth: 100 }}>
              Confirm
            </Button>
          </DialogActions>
        </Dialog>
      </Container>
    </>
  );
}
